// @flow
import config from '../config';

export const fetchZendeskUrl = (token: string) =>
  fetch(config.ZENDESK_URL, {
    method: 'GET',
    headers: {
      Authorization: token,
      Pragma: 'no-jwt-cookie',
    },
  })
    .then(response => response.json())
    .then(data => data.redirectUrl);
